// @flow
import FormBuilderSettingsCard from 'pages/Components/FormBuilderSettingsCard'
import FormBuilderSettingsNotificationsPacketConsumer from 'pages/FormBuilderSettingsNotifications/Components/FormBuilderSettingsNotificationsPacketConsumer'
import NotificationsForm from 'pages/FormBuilderSettingsNotifications/Components/NotificationsForm'
import * as React from 'react'
import { Link } from 'react-router-dom'
import Text from 'ui/atoms/Text'

import FormBuilderSettingsNotificationsDocumentConsumer from './Components/FormBuilderSettingsNotificationsDocumentConsumer'
import FormBuilderSettingsNotificationsFormConsumer from './Components/FormBuilderSettingsNotificationsFormConsumer'

type Props = {
  resourceType?: 'form' | 'document' | 'packet',
}

function FormBuilderSettingsNotifications({
  resourceType = 'form',
}: Props): React.Node {
  const Consumer = React.useMemo(() => {
    switch (resourceType) {
      case 'document':
        return FormBuilderSettingsNotificationsDocumentConsumer
      case 'packet':
        return FormBuilderSettingsNotificationsPacketConsumer
      case 'form':
        return FormBuilderSettingsNotificationsFormConsumer
      default:
        throw new Error('Invalid resource type')
    }
  }, [resourceType])

  let notificationDescription =
    'Receive an email when someone completes your packet.'
  if (resourceType === 'form') {
    notificationDescription =
      'Receive an email when someone completes your form.'
  }
  if (resourceType === 'document') {
    notificationDescription =
      'Receive an email when someone completes your document.'
  }

  return (
    <FormBuilderSettingsCard
      subtitle={
        <>
          <Text $light>{notificationDescription}</Text>
          <Text $light>
            You can edit notifications for all forms, pdfs and packets in{' '}
            <Link className="text-blue-400 underline" to="/settings">
              settings
            </Link>
            .
          </Text>
        </>
      }
      title="Notifications"
    >
      <Consumer>
        {({ notificationUsers, setNotificationUsers, setIsDirty }) => (
          <NotificationsForm
            notificationUsers={notificationUsers}
            setNotificationUsers={(value) => {
              setNotificationUsers(value)
              setIsDirty?.(true)
            }}
          />
        )}
      </Consumer>
    </FormBuilderSettingsCard>
  )
}

export default FormBuilderSettingsNotifications
